export const AI_EXTRACTION_JOB_TYPES = {
  clientOcr: 'client_ocr',
  geminiExtraction: 'gemini_extraction',
  modelSuggestion: 'model_suggestion',
  photoQuality: 'photo_quality',
  readingValidation: 'reading_validation',
  speechToText: 'speech_to_text',
} as const;

export type AiExtractionJobType = (typeof AI_EXTRACTION_JOB_TYPES)[keyof typeof AI_EXTRACTION_JOB_TYPES];

export const AI_EXTRACTION_STATUSES = {
  failed: 'failed',
  queued: 'queued',
  running: 'running',
  skipped: 'skipped',
  succeeded: 'succeeded',
} as const;

export type AiExtractionStatus = (typeof AI_EXTRACTION_STATUSES)[keyof typeof AI_EXTRACTION_STATUSES];

export interface AiExtraction {
  id: string;
  sessionId: string;
  photoId?: string;
  jobType: AiExtractionJobType;
  status: AiExtractionStatus;
  output: Record<string, unknown>;
  confidence?: number;
  createdAt: string;
  completedAt?: string;
  errorCode?: string;
}
